export const getErrorMessage = (t: any, errorType: number) => {
  const errorTypesMessages = [
    '',
    'calendar_widget_noCalendarsPublic',
    'calendar_widget_calendarsAreUnchecked',
    'calendar_widget_canNotGetDataFromAPI',
  ];
  return errorTypesMessages[errorType];
};
